var React = require('react');

function SliderArrowRightBlack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 21L80 21","stroke":"#101010","strokeWidth":"1.4","key":0}),React.createElement("path",{"d":"M58.5 1L80 21L58.5 41","stroke":"#101010","strokeWidth":"1.4","key":1})]);
}

SliderArrowRightBlack.defaultProps = {"width":"82","height":"42","viewBox":"0 0 82 42","fill":"none"};

module.exports = SliderArrowRightBlack;

SliderArrowRightBlack.default = SliderArrowRightBlack;
